import React, { Suspense, useRef, useState } from 'react';
import { Stage } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { Model } from './Model';
import { Button, Stack, Container } from 'react-bootstrap';
import { CaretRight, CaretLeft, ArrowRight } from 'react-bootstrap-icons';
import { bodyMap } from "./BodyMap";

export function DisplayModel({ parentRef, setModalShow, setBodyPartsSelected }) {
  const ref = useRef()
  const [selectedBodyParts, setSelectedBodyParts] = useState([]);
  const [showFront, setShowFront] = useState(true);

  const getQuoteClicked = (e) => {
    setModalShow(true);
    setBodyPartsSelected(selectedBodyParts.map(x => bodyMap.get(x)));
  }

  return (
    <Container className="py-5">
      <div className="text-center mb-4">
        <span className="qmi-section-label">Interactive Tool</span>
        <h2 className="racing-sans-one-regular" style={{ color: '#007EF2', fontSize: 'clamp(1.5rem, 4vw, 2.5rem)' }}>
          Select Your Injured Body Parts
        </h2>
        <p style={{ color: '#666', maxWidth: '500px', margin: '0 auto' }}>
          Click on the 3D model to select up to 4 injured areas. Use the arrows to rotate between front and back views.
        </p>
      </div>

      <div className="justify-content-md-center" style={{ height: "65vh", width: "100%" }}>
        <Stack direction="horizontal" gap={2} className="col-md-6 mx-auto h-100">
          <button
            className="rotate-btn"
            onClick={() => setShowFront(!showFront)}
            aria-label="Rotate left"
          >
            <CaretLeft size={40} />
          </button>

          <div style={{ height: "100%", width: "100%", position: 'relative' }}>
            <Canvas shadows dpr={[1, 2]} camera={{ fov: 50 }}>
              <Suspense fallback={null}>
                <Stage controls={ref} preset="rembrandt" intensity={2} contactShadow={false} environment="studio">
                  <Model
                    showFront={showFront}
                    setModalShow={setModalShow}
                    selectedBodyParts={selectedBodyParts}
                    setSelectedBodyParts={setSelectedBodyParts}
                  />
                </Stage>
              </Suspense>
            </Canvas>
          </div>

          <button
            className="rotate-btn"
            onClick={() => setShowFront(!showFront)}
            aria-label="Rotate right"
          >
            <CaretRight size={40} />
          </button>
        </Stack>
      </div>

      <Stack gap={3} className="col-md-7 mx-auto justify-content-md-center text-center mt-4">
        {selectedBodyParts.length > 0 ? (
          <div className="selected-parts-indicator">
            <span className="selected-count">{selectedBodyParts.length}</span>
            <span className="selected-label">/ 4 Body Parts Selected</span>
          </div>
        ) : (
          <p style={{ color: '#888' }}>Tap on the body to select injured areas</p>
        )}

        {selectedBodyParts.length > 0 && (
          <Button
            className="qmi-btn-accent qmi-btn-lg hover-lift"
            onClick={getQuoteClicked}
          >
            <span className='racing-sans-one-regular'>Get My Quote</span>
            <ArrowRight size={20} className="ms-2" />
          </Button>
        )}
      </Stack>
    </Container>
  );
}
